import React from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { useToggleCompareItem } from "../../hooks/useToggleCompareItem";
import Icon from "../../../../../common/components/Icon/Icon";

interface CompareToggleButtonProps {
  productId: number;
  className?: string;
}

const CompareToggleButton: React.FC<CompareToggleButtonProps> = ({
  productId,
  className,
}) => {
  const { t } = useTranslation();
  const { handleToggle, isInCompare, isLoading } =
    useToggleCompareItem(productId);

  const isApprovedMember = Boolean(window.commonVariables?.isApprovedMember);
  const loginUrl = window.commonVariables?.loginUrl || "/login";

  const title = isInCompare
    ? t("compareToggleButton.removeFromCompareTitle", "Remove from Compare")
    : t("compareToggleButton.addToCompareTitle", "Add to Compare");

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isApprovedMember) {
      e.preventDefault();
      e.stopPropagation();
      toast.error(
        t(
          "compare.loginRequired",
          "Ürünleri karşılaştırabilmek için lütfen giriş yapın.",
        ),
      );
      setTimeout(() => {
        window.location.href = loginUrl;
      }, 1000);
      return;
    }
    handleToggle(e);
  };

  return (
    <button
      className={`compare-toggle-button ${className || ""} ${
        isInCompare ? "is-active" : ""
      }`}
      aria-label={title}
      title={title}
      onClick={handleClick}
      disabled={isLoading}
    >
      <Icon iconName="arrows-right-left" className="icon--stroke-thick" />
    </button>
  );
};

export default CompareToggleButton;
